import { API_URL } from 'constants';

export const POSITION_CHANGE_REQUESTS_URL = `${API_URL}/api/v1/positionchangerequests`;
export const MY_POSITION_CHANGE_REQUESTS_URL = `${POSITION_CHANGE_REQUESTS_URL}/mine?pageNumber=1&pageSize=2`;
export const cancelPositionChangeRequestUrl = (id) =>
    `${POSITION_CHANGE_REQUESTS_URL}/${encodeURIComponent(id)}/cancel`;
export const PENDING_POSITION_REQUEST_COUNT_URL = `${POSITION_CHANGE_REQUESTS_URL}/pending-count`;
export const positionRequestQueueUrl = ({ page, pageSize }, search) =>
    `${POSITION_CHANGE_REQUESTS_URL}?${new URLSearchParams({
        status: 'Pending', pageNumber: String(page + 1), pageSize: String(pageSize), search,
    })}`;
export const positionRequestDecisionUrl = (id, action) =>
    `${POSITION_CHANGE_REQUESTS_URL}/${encodeURIComponent(id)}/${action}`;
